
import { join, substring } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { min, max } from "../fable_modules/fable-library-js.5.0.0-rc.2/Double.js";
import React from "react";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

function getRGB(c) {
    return parseInt(c, 16) | 0;
}

function getsRGB(c) {
    const rgb = getRGB(c);
    if ((rgb / 255) <= 0.03928) {
        return (rgb / 255) / 12.92;
    }
    else {
        return Math.pow(((rgb / 255) + 0.055) / 1.055, 2.4);
    }
}

function getLuminance(hexColor) {
    return ((0.2126 * getsRGB(substring(hexColor, 1, 2))) + (0.7152 * getsRGB(substring(hexColor, 3, 2)))) + (0.0722 * getsRGB(substring(hexColor, hexColor.length - 2)));
}

function getContrast(f, b) {
    const L1 = getLuminance(f);
    const L2 = getLuminance(b);
    return (max(L1, L2) + 0.05) / (min(L1, L2) + 0.05);
}

function getTextColor(bgColor) {
    if (getContrast(bgColor, "#ffffff") > getContrast(bgColor, "#000000")) {
        return "#ffffff";
    }
    else {
        return "#000000";
    }
}

export function Badge(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["style", {
        backgroundColor: props.Color,
        color: getTextColor(props.Color),
    }], ["className", join(" ", ["flex", "h-6", "text-xs", "mr-2", "px-2.5", "py-0.5", "rounded-xl", "items-center", "justify-center", "max-w-full", "min-w-0"])], ["data-test-id", props.TestId], (elems = [reactElement("span", {
        className: join(" ", ["truncate"]),
        children: props.Label,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

